export const iGen = (index: number) => `index-${index}`
